<template>
  <div class="tms_slider">
    <el-form-item
      :label="field['label-show'] === false ? '' : field.name + '：'"
      label-width="110px"
    >
      <el-slider :min='field["min"] || 0' :max='field["max"] || 100' v-model="value" @input="change"></el-slider>
    </el-form-item>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: "tms-type-slider",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      value: 0,
    };
  },
  methods: {
    change(value) {
      this.$set(this.config, this.field.key, value);
    },
  },
  created() {
    this.value = this.config[this.field.key];
  },
};
</script>
